export default {
    colors: {
        brand: {
            500: '#1652f0',
        }
    },
}